/**
 * cs-pdp-sticky-atc.js — Cadouri Superbe Phase 3
 * Mobile sticky Add-to-Cart bar.
 *
 * Uses IntersectionObserver to detect when the main ATC button
 * leaves the viewport, then reveals the sticky bar.
 *
 * The sticky button delegates its click to the main form's submit
 * button so product-form.js handles the cart add correctly.
 */

(function () {
  'use strict';

  function initStickyAtc() {
    const stickyBar = document.querySelector('.cs-pdp-sticky');
    if (!stickyBar) return;

    // Find the main ATC submit button (product-form.js wires this up)
    const mainAtc = document.querySelector(
      '.product-form__submit[name="add"]'
    );
    if (!mainAtc) return;

    // IntersectionObserver: show sticky when main ATC is NOT visible
    const observer = new IntersectionObserver(
      ([entry]) => {
        const visible = entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      },
      { threshold: 0.1 }
    );
    observer.observe(mainAtc);

    // Sync disabled state when variant changes
    function syncDisabledState() {
      const stickyBtn = stickyBar.querySelector('.cs-pdp-sticky__btn');
      if (!stickyBtn) return;
      if (mainAtc.disabled) {
        stickyBtn.setAttribute('disabled', '');
        stickyBtn.textContent =
          mainAtc.querySelector('.sold-out-message')?.textContent?.trim() ||
          mainAtc.innerText?.trim() ||
          stickyBtn.dataset.soldOut ||
          stickyBtn.textContent;
      } else {
        stickyBtn.removeAttribute('disabled');
        stickyBtn.textContent = stickyBtn.dataset.label || stickyBtn.textContent;
      }
    }

    // Delegate sticky button click to main ATC
    const stickyBtn = stickyBar.querySelector('.cs-pdp-sticky__btn');
    if (stickyBtn) {
      // Store original label
      stickyBtn.dataset.label = stickyBtn.textContent.trim();

      stickyBtn.addEventListener('click', function () {
        if (!mainAtc.disabled) {
          mainAtc.click();
        }
      });
    }

    // Listen for Shopify variant change events (Dawn uses custom events)
    document.addEventListener('variant:change', syncDisabledState);
    // Dawn's pubsub event
    if (window.Shopify && window.subscribe) {
      window.subscribe('variant:change', syncDisabledState);
    }

    // Initial sync
    syncDisabledState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }
})();
